import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { COLORS } from '@collections/colors'

export const StyledWrapper = styled(Box)(() => ({
  '.MuiFormHelperText-root': {
    color: COLORS.red
  }
}))
